import React from 'react';

import type { IModeToggleSwitchProps } from './ModeToggleSwitch.types';
import { ChatMode } from './ModeToggleSwitch.types';
import { Text } from '../Text/Text';
import { Icon } from '../Icon/Icon';
import { IconName } from '../Icon/Icon.type';

export const ModeToggleSwitch: React.FC<IModeToggleSwitchProps> = ({
  activeMode,
  onModeChange,
  className = '',
  disabled = false,
  showTickets = false,
}) => {

  const handleModeClick = (mode: ChatMode) => {
    if (!disabled && mode !== activeMode) {
      onModeChange(mode);
    }
  };

  const modes: { mode: ChatMode; label: string; icon: IconName }[] = [
    { mode: ChatMode.CAB, label: 'CAB', icon: IconName.Document },
    ...(showTickets ? [{ mode: ChatMode.TICKETS, label: 'Tickets', icon: IconName.Tickets }] : []),
    { mode: ChatMode.DESIGN, label: 'Prototype', icon: IconName.Design },
    { mode: ChatMode.BUILD, label: 'Build', icon: IconName.Code },
  ];

  return (
    <div
      className={`bg-bg-tertiary rounded-bg-v2-3xl p-bg-v2-xs gap-bg-v2-xs flex ${className}`}
      role="group"
      aria-label="Mode toggle"
    >
      {modes.map(({ mode, label, icon }) => (
        <button
          key={mode}
          type="button"
          onClick={() => handleModeClick(mode)}
          disabled={disabled}
          className={`
            rounded-bg-v2-3xl px-bg-v2-lg py-bg-v2-md
            flex items-center gap-bg-v2-xs
            transition-all duration-200 ease-in-out
            cursor-pointer
            border-none outline-none
            ${activeMode === mode ? 'bg-bg-primary container-shadow-sm' : 'bg-transparent'}
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-bg-secondary'}
          `}
          aria-pressed={activeMode === mode}
        >
          <Icon
            name={icon}
            size="sm"
            className={activeMode === mode ? '!text-text-brand-primary' : "text-text-tertiary-hover"}
            inheritColor
          />
          <Text
            variant="text-sm"
            className={activeMode === mode ? '!text-text-brand-primary' : 'text-text-tertiary-hover'}
            weight="semibold"
            as="span"
          >
            {label}
          </Text>
        </button>
      ))}
    </div>
  );
};

